export function generateUrlForWorkspace(workspaceNumber) {
    return "/ws/" + workspaceNumber;
}
